var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState, useCallback } from 'react';
import * as contentServices from '../services/contentServices';
import { useSession } from 'next-auth/react';
import { useRouter } from 'next/router';
import handlebars from 'handlebars';
export const ContentDisplay = (props) => {
    const { data: session } = useSession();
    const { locale } = useRouter();
    const [pageContent, setPageContent] = useState('');
    function evalPrecompiledTemplate(s) {
        return eval(`(function(){return ${s}}());`);
    }
    const getContent = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        console.log({
            key: props.contentKey,
            language: props.languageCode,
        });
        const contentResult = yield contentServices.getContentList({
            key: props.contentKey,
            language: props.languageCode,
        }, (e) => console.log(`Error getting content '${props.contentKey}'`, e));
        if (!contentResult.success || !contentResult.data) {
            return '';
        }
        const content = contentResult.data;
        if (content.length <= 0) {
            return '';
        }
        const theContent = content[0];
        const isLoggedIn = !!session;
        const isCrew = (_a = session === null || session === void 0 ? void 0 : session.user) === null || _a === void 0 ? void 0 : _a.crewApproved;
        const isPress = (_b = session === null || session === void 0 ? void 0 : session.user) === null || _b === void 0 ? void 0 : _b.pressApproved;
        const isBand = false;
        try {
            if (theContent.template) {
                let templateSpec = evalPrecompiledTemplate(theContent.template);
                if (typeof templateSpec === 'string') {
                    templateSpec = evalPrecompiledTemplate(templateSpec);
                }
                const template = handlebars.template(templateSpec);
                const context = {
                    isLoggedIn: isLoggedIn,
                    isAnonymous: !isLoggedIn,
                    isCrew: isCrew,
                    isPress: isPress,
                    isBand: isBand,
                    isOnlyVisitor: !isCrew && !isPress && !isBand,
                    user: session === null || session === void 0 ? void 0 : session.user,
                };
                return template(context);
            }
            else {
                return theContent.text;
            }
        }
        catch (e) {
            console.log(`Failure to apply the handlebars template "${props.contentKey}:${props.languageCode}"`, e);
            return '';
        }
    }), [props.contentKey, props.languageCode, session]);
    useEffect(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            setPageContent(yield getContent());
        }))();
    }, [getContent, locale]);
    return (<>
      <div dangerouslySetInnerHTML={{ __html: pageContent }}/>
    </>);
};
